export const wallet = {
  wallet_deposits: "存款",
  // withdrawal_info_phone: "为确保资金到达正确的账户，请确认显示的号码是您的电话号码。",
  // withdrawal_info_phone_2: "我们将把您申请的款项发送到这个号码。",
  // phone_number_registered: "已注册的电话号码：",
  // accounts: {
  //   selectBank: "选择银行",
  //   phoneNumber: "电话号码：",
  //   amount: "金额：",
  //   account: "账户：",
  //   noAccounts: "您尚未注册账户",
  //   addAccountPagoMovil: "添加手机支付账户",
  // },
  // yourBalance: "可用余额：",
  // notBalanceAvailable: "余额不足",
  // balanceInsufficient: "余额不足",
  // isAmountEmpty: "请输入金额",
  // areYouSure: "您确定要提取 ",
  // entityBank: "银行实体",
  // phoneNumber: "电话号码",
  // amountWithdraw: "提取金额",
  // withdrawTitle: "提取现金",
  // yourBalanceLeft: "您的剩余余额将为：",
  // movements: {
  //   deposits: "存款",
  //   transfers: "转账",
  //   withdrawals: "提款",
  //   plays: "游戏",
  // },
  // transactions: {
  //   sent: "发送给",
  //   received: "收到自",
  //   rygBet: "投注",
  //   rygWin: "奖金",
  //   rygRefund: "退款",
  //   withdrawal: "提款",
  //   deposits: "存款",
  // }
};

export default wallet;
